import React from 'react';
import styled from 'styled-components';
import { Modal, Button, Divider, App } from 'antd';
import { FaEnvelope, FaCopy } from 'react-icons/fa6';

const MetaRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
  color: #334155;
`;
const MetaItem = styled.div`
  font-size: 14px;
`;

const InviteTextArea = styled.textarea`
  width: 100%;
  height: 140px;
  margin-top: 8px;
  padding: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #f5f5f5;
  color: #111827;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  resize: none;
`;

const ShareInvitationModal = ({
  isOpen,
  name,
  email,
  inviteLink,
  onCopyLink,
  onSendEmail,
  onClose,
}) => {
  const { message } = App.useApp();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink || '');
      message.success('Invitation link copied');
      if (onCopyLink) await onCopyLink();
    } catch (e) {
      message.error('Failed to copy link');
    }
  };

  const handleSend = async () => {
    try {
      const result = await (onSendEmail ? onSendEmail() : Promise.resolve(true));
      if (result === false) return; // parent reported failure
      message.success('Invitation sent successfully');
    } catch (e) {
      // parent likely handled error; add fallback
      message.error('Failed to send invitation');
    }
  };

  return (
    <Modal
      title="Share Invitation"
      open={!!isOpen}
      onCancel={onClose}
      footer={null}
      maskClosable
      maskStyle={{ backdropFilter: 'blur(2px)', WebkitBackdropFilter: 'blur(2px)', backgroundColor: 'rgba(0,0,0,0.35)' }}
      width={640}
      destroyOnClose
    >
      {name ? <div style={{ marginBottom: 4, color: '#334155' }}><strong>Name:</strong> {name}</div> : null}
      {email ? <div style={{ marginBottom: 8, color: '#334155' }}><strong>Email:</strong> {email}</div> : null}
      <Divider style={{ margin: '8px 0 12px' }} />
      <div style={{ fontWeight: 600, marginTop: 8 }}>Invitation Link:</div>
      <InviteTextArea readOnly value={inviteLink || ''} />
      <div style={{ display: 'flex', gap: 12, marginTop: 16, justifyContent: 'center' }}>
        <Button type="primary" onClick={handleSend} icon={<FaEnvelope />}>
          Send Email
        </Button>
        <Button type="primary" onClick={handleCopy} icon={<FaCopy />}>
          Copy Link
        </Button>
      </div>
    </Modal>
  );
};

export default ShareInvitationModal;
